module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "CH-T",
    attrs: {
      "id": "toc_marker-4"
    }
  }, [_c('a', {
    attrs: {
      "id": "Modelling"
    }
  }, [_vm._v("Modelling")])]), _c('a', {
    attrs: {
      "id": "Modelling"
    }
  }, [_c('p', {
    staticClass: "BOD1"
  }, [_vm._v("Mastering modelling with sugarpaste is the key to creating professional-looking cakes. This section reveals all the tools and techniques you need to help sharpen your modelling skills. ")])]), _c('h3', {
    staticClass: "BHD"
  }, [_c('a', {
    attrs: {
      "id": "Modelling"
    }
  }), _c('a', {
    attrs: {
      "id": "Basic-Tool-Kit"
    }
  }), _c('a', {
    attrs: {
      "id": "General-Equipment"
    }
  }, [_vm._v("Basic Tool Kit")])]), _c('a', {
    attrs: {
      "id": "General-Equipment"
    }
  }, [_c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("There are myriad tools on the market for cake decorating and sugarcraft, but many of them are simply unnecessary. The following list gives my recommended essentials, and these are the items that form the basic tool kit listed in each of the projects in this book. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Large non-stick rolling pin")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For rolling out sugarpaste and marzipan. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Wooden spacing rods (1)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59516.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For achieving an even thickness when rolling out sugarpaste – available in various thicknesses. Also useful when cutting out letters and cookies. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Two cake smoothers with handles (2)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59515.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For smoothing sugarpaste when covering cakes – use two smoothers together for a professional finish. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Flower former (3)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59525.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For placing delicate parts in while working on them so that they do not lose their shape. This one is perfect for holding heads in an upright position to complete them.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Paint palette (4)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59524.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For mixing liquid food colour or dust food colour and clear alcohol to paint on sugarpaste. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Quality sable paintbrushes (5)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59526.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For painting on sugarpaste and for modelling – used mainly for painting facial features and applying edible glue. The end of a paintbrush can be pushed into models to create nostrils, used to curl laces of paste around to make curly tails or hair, and to open up flower petals. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Textured rolling pins (6)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/45287.jpg"
    }
  })])]), _c('p', {
    staticClass: "BOD-BL2"
  }, [_c('a', {
    attrs: {
      "id": "General-Equipment"
    }
  }, [_vm._v("For creating decorative patterns in paste – for example, ribbed or daisy-patterned. Impression mats do a similar job (see ")]), _c('a', {
    attrs: {
      "href": "#/#Texturing-Sugarpaste"
    }
  }, [_vm._v("Texturing Sugarpaste")]), _vm._v("). ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Pastry brush")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For painting apricot glaze and clear spirits onto fruit cakes. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Non-stick flexi mat (7)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59523.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For placing over modelled parts to prevent them drying out – freezer bags can be used.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Cutting wheel (8)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59520.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For making smooth cuts on long pieces of sugarpaste, mainly for use on borders. A pizza cutter can be used instead. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Plastic marzipan knife")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For trimming the edges of cakes and boards for neat results. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Hair gun (9)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59518.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For extruding lengths of paste to make grass, wool, fluff and hair. This amazing little tool is the one I have used for making all the strands of hair in this book. It is very easy to use but you must add white vegetable fat to the paste to soften it beforehand, then it becomes self cleaning. A standard garlic press, found in many kitchens, is also very effective for this.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Plunger cutters (10)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59519.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For cutting out different shapes in sugarpaste, such as daisies, hearts, stars and flowers. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Good-quality stainless steel cutters (11)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/52127.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("Essential for cutting out clean shapes for use in decorations, especially in the very small sizes. These come in all sorts of shapes – round, square, oval, butterfly, heart, petal/blossom – in assorted sizes from 6mm ("), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in) upwards.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Frilling tool")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For making frills in sugarpaste and sugar flower paste pieces. A cocktail stick (toothpick) or end of a paintbrush could be used. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Bead maker")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("A handy mould for creating strings of 3D circles and ovals.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Cake cards")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For placing sugarpaste models on while working on them before transferring them to the cake. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Mini turntable (12)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59522.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("Useful for placing a cake on so that it can be turned around easily while working on it. Although not strictly essential you will find one a useful addition to your kit. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Measuring cups")])]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("For measuring out powders and liquids quickly and cleanly. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Polystyrene blanks (13)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59925.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("Easily covered with sugarpaste and ideal for sitting figures on, these will also add shape and dimension to your design. Available in all shapes and from very small sizes. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-1st"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Cake boards/drums (14)")])]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59521.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2-last"
  }, [_vm._v("For supporting finished cakes – 12mm ("), _c('sup', {
    staticClass: "num"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("2")]), _vm._v("in) thickness is ideal. ")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Specific Modelling Tools ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("A whole book could be filled talking about these, as there are so many different varieties available. However, I use the white plastic set that has a number on each tool. I refer to the number on the tool throughout the book. They are inexpensive, light and easy to work with and are available to buy from my website (see "), _c('span', {
    attrs: {
      "href": "#/c14#Suppliers",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Suppliers")]), _vm._v(").")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59532.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "BOX-AHD"
  }, [_vm._v("Securing and Supporting Your Models")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("Sugarpaste models need to be held together in several ways. Small parts can be attached with edible glue (see "), _c('span', {
    attrs: {
      "href": "#/c03#Recipes",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Recipes")]), _vm._v("), but larger parts, such as heads and arms, will require additional support.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("Throughout the book I use pieces of dry spaghetti for this purpose. The spaghetti is inserted into the models – into the hip, shoulder or body, for example – onto which you can attach another piece – the leg, arm or head. Leave 2cm ("), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("4")]), _vm._v("in) showing at the top to support the head, and 1cm ("), _c('sup', {
    staticClass: "num"
  }, [_vm._v("3")]), _vm._v("⁄"), _c('sub', {
    staticClass: "den"
  }, [_vm._v("8")]), _vm._v("in) to support arms and legs.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("The pieces will still require some edible glue to bond them, but will have more support and will stay rigid. When inserting spaghetti to support heads, make sure that it is pushed into the body in a very vertical position otherwise the head will tilt backwards and become vulnerable. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("I recommend using dry raw spaghetti because it is food and is much safer than using cocktail sticks (toothpicks), which could cause harm, particularly to children. However, I would always advise that any spaghetti pieces used are removed before eating the cake and decorations. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2"
  }, [_vm._v("Sugarpaste models sometimes need to be supported with foam or cardboard while they are drying to prevent parts from flopping over or drooping down. Advice on where this may be necessary is given in the project instructions.")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture694_Intro_fmt1.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_c('a', {
    attrs: {
      "id": "Basic-Shapes"
    }
  }, [_vm._v("Basic Shapes")])]), _c('a', {
    attrs: {
      "id": "Basic-Shapes"
    }
  }, [_c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("There are four basic shapes required for modelling. Every character in this book begins with a ball; this shape must be rolled first, regardless of whatever shape you are trying to make. ")]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("Ball")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("The first step is always to roll a ball. We do this to ensure that we have a perfectly smooth surface, with no cracks or creases.")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("For example:")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("If you pull out the ball at the front, you can shape it into a face. ")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/FrontofBook_Tech1_amend_fmt.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/BallImage2_fmt.png"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("Sausage")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("This shape is used for creating arms and legs. It is made by rolling and narrowing the ball at one end, leaving it fatter at the other end.")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("For example:")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("The sausage shape when turned up at the end will form a foot, or can be marked to make toes. ")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/FrontofBook_Tech1_amen_fmt1.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/FrontofBook_Tech2_amend_fmt.png"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("Cone")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("This is the basic shape for bodies. Bows can also be made from flattened cones.")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("For example:")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("The cone can be pulled out at the widest part to form the tail of a duck. ")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/FrontofBook_Tech1_amen_fmt2.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/FrontofBook_Tech2_amen_fmt1.png"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("Oval")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("This is the least used of the basic shapes, but is used to make cheeks, ears and other small parts. It is made in the same way as the sausage, by applying even pressure to the ball, but not taking it as far.")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("For example:")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("Tiny oval shapes can be used for glamorous fingernails, or small ovals can be pinched at one end to make wings and also ears. ")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/FrontofBook_Tech1_amen_fmt3.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/FrontofBook_Tech2_amen_fmt2.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1")]), _vm._v(" Start by rolling a ball into a pear shape. Add a small oval for the nose and attach to the centre of the face. Using tool no.11, indent the top and bottom of the mouth leaving a space in between. Join the edges at the sides"), _c('strong', {
    staticClass: "Bold"
  }, [_vm._v(" (A)")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59533.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2")]), _vm._v(" Hold the head in one hand and with the little finger of your other hand, indent the eye area by rocking the shape backwards and forwards a couple of times. Then, using the end of your paintbrush, push the centre of the mouth inside the head to make a cavity "), _c('strong', {
    staticClass: "Bold"
  }, [_vm._v("(B)")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59534.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("3")]), _vm._v(" Roll a small banana shape for the teeth and place it under the top lip. Make two cone shapes in white for the eyeballs and attach just above and on either side of the nose. Add two small balls of dark blue sugarpaste to the top, and two smaller balls of black for the pupils. Roll two teardrop shapes for the ears and attach to either side of the head, keeping the top of each ear in line with the centre of the eyes. Indent the ears at the base with the end of your paintbrush "), _c('strong', {
    staticClass: "Bold"
  }, [_vm._v("(C)")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59535.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("4")]), _vm._v(" Roll two red banana shapes for the lips and attach to the mouth. Outline the eyes with a tiny lace of black sugarpaste and add the eyebrows in the same way "), _c('strong', {
    staticClass: "Bold"
  }, [_vm._v("(D)")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59536.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("5")]), _vm._v(" Add the final details such as hair (see Hairstyles) and earring. Highlight the eyes with a dot of white edible paint on the end of a cocktail stick (toothpick) and dust the cheeks with pink dust food colour to give a healthy glow "), _c('strong', {
    staticClass: "Bold"
  }, [_vm._v("(E)")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59537.jpg"
    }
  })])]), _c('h3', {
    staticClass: "BHD"
  }, [_c('a', {
    attrs: {
      "id": "Basic-Shapes"
    }
  }), _c('a', {
    attrs: {
      "id": "Constructing-a-Head"
    }
  }, [_vm._v("Constructing a Head")])]), _c('a', {
    attrs: {
      "id": "Constructing-a-Head"
    }
  }, [_c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("This step-by-step demonstration shows you how to make a female head bursting with life. She has lots of details in the construction of the face.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("A man’s face has fewer details than a woman’s but there are still key ways to add personality and character.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1")]), _vm._v(" After rolling the head shape and indenting the eye area (see step 2 above), add a large cone shape for the nose. Mark the nostrils with tool no.5. Press the edge of a small circle cutter below the nose to mark the mouth. Add two small lines at either end of the mouth "), _c('strong', {
    staticClass: "Bold"
  }, [_vm._v("(A)")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59539.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2")]), _vm._v(" Roll two oval shapes in white for the eyes and attach on either side of the nose. Add a small black pupil to each eye. Add small banana shapes of flesh-coloured sugarpaste for the eyelids and add the eyebrows with a thin black lace. Make two cone shapes for the ears and attach to each side, indenting them with the end of your paintbrush "), _c('strong', {
    staticClass: "Bold"
  }, [_vm._v("(B)")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59540.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("3")]), _vm._v(" For the hair, roll flattened cones of black sugarpaste and secure into style on top of the head. To finish, add a sliver of black to outline each eyelid, highlight the eyes with a dot of white edible paint on the end of a cocktail stick (toothpick) and dust the cheeks with pink dust food colour "), _c('strong', {
    staticClass: "Bold"
  }, [_vm._v("(C)")]), _vm._v(".")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59541.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "SBDIV"
  }, [_c('hr'), _vm._v(" "), _c('h4', {
    staticClass: "TIP-AHD"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "TIP1"
  }, [_vm._v("Use a flower former to hold the head in shape while you work on it. ")]), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Using Head Shape to Add Personality")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("A crucial factor in imbuing your characters with personality is the shape of the head. The following examples show how using different head shapes can create a vast range of personas. ")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59542.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59543.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59544.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59545.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59546.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59547.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59548.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59549.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59550.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("Man’s style")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("We will use the same technique on the two other men’s hairstyles, but the look will be quite different.")]), _vm._v(" "), _c('p', {
    staticClass: "CAP2"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Style one:")]), _vm._v(" Apply the hair to the back and sides of the head in a single layer. Take several short strands to make a quiff and attach them to the front of the head, bringing the hair forward and then taking it backwards.")]), _vm._v(" "), _c('p', {
    staticClass: "CAP2"
  }, [_c('strong', {
    staticClass: "Bold"
  }, [_vm._v("Style two:")]), _vm._v(" For the second style, again apply a single layer of strands to the back and sides of the head, but this time extrude very short strands for the top. To make the hair thinner, I have scored it with the knife tool. ")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59554.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Head and Body Shapes ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-BL2"
  }, [_vm._v("Because most of the bodies in this book have no, or at least very few, clothes you will need to master creating the male and female physique. Start with a basic cone and then follow the steps below. These bodies include the neck, but I’ll explain how to make the neck part of the head as well. The golden rule when making the torso is that you need the same amount of space from the shoulder to the waist, as you do from the waist to the hip. This is most important, otherwise we will not have enough room to dress the upper body and your figure will not look well proportioned.")]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("The female body")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1 ")]), _vm._v("In order to make an adult female body shape, start with the basic cone reversed, and then pull up the neck and shape the shoulder line.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2 ")]), _vm._v("Make a ridge across the chest and divide it.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("3")]), _vm._v(" Mould the round breasts with your fingers to the required size and shape.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("4")]), _vm._v(" Narrow the waist and hips.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("5")]), _vm._v(" This body would require a head without a neck, so roll the paste for a head into a ball. Indent the eye area, lengthen the forehead and accentuate the cheeks.")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture_1113_fmt.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("The male body")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1")]), _vm._v(" This is very much more defined than the female. Begin with the same cone, pulling out the neck and shaping the shoulders. The pecs are less defined and I create these with a very soft paint brush.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2")]), _vm._v(" I also define the six pack with a soft brush and mould and shape with my fingers to soften the lines.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("3")]), _vm._v(" Again, this body type does not require a neck on the head, but we can really mould the shape of the face while the paste is soft. Indent the eye area and press down the paste to form the brow. Shape the cheeks and narrow the shape of the face.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("4")]), _vm._v(" Pull down the jaw line to make it square and manly. Add the nose and begin to add the eyes and mouth as desired.")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture_1113_fmt1.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("Head with neck")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1")]), _vm._v(" If you need to make the neck part of the head, rather than the body, the technique is the same for all shapes. Just begin by rolling the ball and pull down the neck from underneath.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2")]), _vm._v(" Indent the eye area with your finger and then shape the cheeks. This basic shape can become whatever you wish it to be.")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture_1113_fmt2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture336_fmt.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Shaping the Limbs for a Male ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("Remember that these are more muscular and heavier than a female character. ")]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("The arms")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture405_fmt.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("To achieve the correct proportions, the length from the shoulder to the elbow, and from the elbow to the wrist should be the same. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2S"
  }, [_vm._v("The length of the arm to the wrist is usually the same length as the body. The hand is extra.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1")]), _vm._v(" Begin by rolling a ball into a sausage shape. For a male arm this is quite chunky.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2")]), _vm._v(" Indent around the wrist, leaving enough to make the hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("3")]), _vm._v(" Indent the inside of the elbow in the centre of the arm, measuring from the wrist to the top, bending at the elbow.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("4")]), _vm._v(" Round off the top to look muscular, using the soft end of your paintbrush, to emphasize the shapes more.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("5")]), _vm._v(" Flatten the end to form the hand.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("6")]), _vm._v(" Take out the thumb and mark the fingers as required. ")]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("The legs")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("To achieve the correct proportions, the length from the top of the leg to the knee, and from the knee to the ankle should be the same. The measurement for the foot is extra.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1")]), _vm._v(" This limb will require more paste than the arm, so again roll a fat sausage shape.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2")]), _vm._v(" Indent around the ankle, leaving room for the foot.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("3")]), _vm._v(" Indent the back of the knee halfway from the ankle to the top of the leg. Bend the knee to shape.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("4")]), _vm._v(" Continue to work on the back of the ankle and shape the foot. Add the toes. ")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture1114_fmt.jpeg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture1114_fmt1.jpeg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Shaping the Limbs for a Female")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture054_fmt.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("The same technique as that used for a male character applies, except that female limbs are much more elegant. Use the instructions above for male limbs, but study the photo to see the results you are aiming for. ")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Hands and Feet ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("When making an arm, first roll a sausage with rounded ends. Narrow the wrist area by rolling it gently then narrow just above the elbow. Make a diagonal cut at the top of the arm to fit the body shape. Flatten the hand end to look like a wooden spoon. ")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture682_fmt.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59556.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59557.jpg"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Sitting a Figure on the Side of a Cake ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("In order to make your seated figures stable, you need to ensure they are positioned securely on the cake. The back of the knee should sit firmly on the edge of the cake, so that all the upper part of the leg is on the top of the cake. Bear this in mind when you place the body and allow enough space for this to happen. ")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture559_fmt.png"
    }
  })]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Shoes")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("Ladies’ shoes come in many shapes and sizes, the main thing is to make the shape of the sole first.")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/Picture1037_fmt.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1")]), _vm._v(" To make the sole add CMC (Tylose) to the paste to harden. Flatten a short sausage shape to form the foot and instep, and up to the back of the shoe where the heel will be.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2")]), _vm._v(" Make the heel the corresponding height. To keep it in shape you can insert a small piece of dry spaghetti and then attach to the sole. It will need to be supported until dry.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("3")]), _vm._v(" Decorate the front and back of the shoe, depending on the style you choose.")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Clothing")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("A brief glance through the cake designs in this book will reveal that clothing is scant. However, it would be remiss not to look at two important garments for our nearly nude characters. ")]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("Posing pouches")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("These come in many guises – and I am educating myself while researching.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1")]), _vm._v(" Start by rolling out a very small amount of sugarpaste in your chosen colour and cutting out a small triangular shape for the front.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2")]), _vm._v(" Taper the ends of the triangle and attach over the nether regions of your character. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("3")]), _vm._v(" Roll two small laces and attach at each side of the triangle. Take the lace round the back of the character. Complete with a triangle at the back to cover the bottom, if your figure is standing.")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59562.jpg"
    }
  })]), _vm._v(" "), _c('h4', {
    staticClass: "CHD"
  }, [_vm._v("The bikini")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59558.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("Sometimes we have a lot of flesh to cover – and sometimes not so much! Bikinis, however, do not leave a lot to the imagination.")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59560.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("1")]), _vm._v(" For the bikini bottom, take a small amount of your chosen colour of sugarpaste and roll it into a ball. Then roll the ball on your work surface, pulling out the paste on either side to make a pouch shape with strings. Attach this to the lower torso, taking the strings around to the side of the body to make a tie.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("2")]), _vm._v(" Roll out a similar amount for the back of the bikini and cut a small triangle. Attach this to the back of the body, joined with two thin sugarpaste laces. Take the laces to each side of the body.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("3")]), _vm._v(" Make two loops to form a bow and add a small ball in the centre to finish. Make one for either side of the bikini bottom. ")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("4")]), _vm._v(" For the bikini top, roll out another similar sized amount of sugarpaste and cut out a small square. Make a diagonal cut across the square to form two triangle shapes, and then attach one to each breast.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD-LIST1"
  }, [_c('span', {
    staticClass: "SbS-num"
  }, [_vm._v("5")]), _vm._v(" Using the remaining sugarpaste, roll a thin lace to go around the body and another to go around the neck.")])]), _c('h3', {
    staticClass: "BHD"
  }, [_c('a', {
    attrs: {
      "id": "Constructing-a-Head"
    }
  }), _c('a', {
    attrs: {
      "id": "Frilling"
    }
  }, [_vm._v("Frilling")])]), _c('a', {
    attrs: {
      "id": "Frilling"
    }
  }, [_c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("Frills can be used to decorate the side of the cake, or to make the edge of a pillow or a cookie. You will need a special cutter called a Garrett frill cutter, which is available in two types – circle and straight. The circular cutter comes with three inner circles of different sizes to determine the depth of the frill. To make the frill, use a cocktail stick (toothpick), a frilling tool or the end of your paintbrush. Place your chosen tool on the edge of the frill and work it in a backwards and forwards motion, without putting too much pressure on it. The frill will lift where you have rolled. Continue with each section in turn until it is completed. A straight Garrett frill cutter will allow you to make a long frilled strip. The technique for frilling is exactly the same.")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59559.jpg"
    }
  })])]), _c('h3', {
    staticClass: "BHD"
  }, [_c('a', {
    attrs: {
      "id": "Frilling"
    }
  }), _c('a', {
    attrs: {
      "id": "Texturing-Sugarpaste"
    }
  }, [_vm._v("Texturing Sugarpaste")])]), _c('a', {
    attrs: {
      "id": "Texturing-Sugarpaste"
    }
  }, [_c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("A great way of adding interest to your cakes is to use textured patterns in the sugarpaste. Texture can be created using impression mats or with textured rolling pins. These can be used to add designs to a large area, such as a covered cake board, or for smaller details such as clothing. Some of the fantastic textures available are shown in the bikini photograph. ")]), _vm._v(" "), _c('h3', {
    staticClass: "BHD"
  }, [_vm._v("Crimpers")]), _vm._v(" "), _c('p', {
    staticClass: "BOD1S"
  }, [_vm._v("Crimpers can be used in many different ways to decorate and enhance your work. Use them to trim around the edges of your cake boards or to decorate the sides of your cakes – you can make very interesting patterns with great ease. The crimpers I have used are plastic with a silicone ring, but you can also get metal ones. The plastic crimpers are non-stick, lightweight and come in a very handy see-through pack of ten assorted designs.")]), _vm._v(" "), _c('p', {
    staticClass: "BOD2S"
  }, [_vm._v("Place the crimpers over the sugarpaste and gently squeeze the sides together, applying enough pressure to indent the paste, then release. Make further indentations to follow where you left off. It may take a little practice to get the feel of them and not press too hard, but the results are very rewarding.")]), _vm._v(" "), _c('div', {
    staticClass: "Image"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "images/59561.jpg"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b6b741ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c02.vue
// module id = 66
// module chunks = 0